import minKnightMoves from "./board";
export { appGUI };

function createGUI() {
  const appContainer = document.querySelector(".app");
  let startCoord = [];
  let endCoord = [];
  let travailResults = {};

  function createElements() {
    // Button container and buttons section
    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("button-container");

    const titleContainer = document.createElement("div");
    titleContainer.classList.add("title-container");
    const titleTextContainer = document.createElement("a");
    titleTextContainer.classList.add("title-text-container");
    titleTextContainer.textContent = "Knight's Travails";
    titleTextContainer.href = "https://codeberg.org/adriand/knights-travails";
    titleTextContainer.target = "_blank";
    titleContainer.appendChild(titleTextContainer);

    const resultsContainer = document.createElement("div");
    resultsContainer.classList.add("results-container");
    const resultsTextContainer = document.createElement("span");
    resultsTextContainer.classList.add("results-text-container");
    resultsContainer.appendChild(resultsTextContainer);

    const startCoordButton = document.createElement("button");
    startCoordButton.classList.add("button-start-coord");
    startCoordButton.textContent = "Select Start";
    startCoordButton.addEventListener("click", captureStartCoord);

    const endCoordButton = document.createElement("button");
    endCoordButton.classList.add("button-end-coord");
    endCoordButton.textContent = "Select End";
    endCoordButton.addEventListener("click", captureEndCoord);

    const initiateTravail = document.createElement("button");
    initiateTravail.classList.add("button-initiate-travail");
    initiateTravail.textContent = "Travail";
    initiateTravail.addEventListener("click", startTravailling);

    const clearBoard = document.createElement("button");
    clearBoard.classList.add("button-clear-board");
    clearBoard.textContent = "Clear Board";
    clearBoard.addEventListener("click", clickClearBoard);

    buttonContainer.appendChild(titleContainer);
    buttonContainer.appendChild(resultsContainer);
    buttonContainer.appendChild(startCoordButton);
    buttonContainer.appendChild(endCoordButton);
    buttonContainer.appendChild(initiateTravail);
    buttonContainer.appendChild(clearBoard);

    appContainer.appendChild(buttonContainer);

    // board section
    const boardContainer = document.createElement("div");
    boardContainer.classList.add("board-container");

    let board = [];
    for (let i = 0; i < 8; i++) {
      board[i] = [];
      for (let j = 0; j < 8; j++) {
        board[i][j] = [i, j];
        const boardElement = document.createElement("div");
        // add CSS classes to help style the chessboard
        boardElement.classList.add("board-element");
        if ((i + j) % 2 === 0) {
          boardElement.classList.add("light-board-element");
        } else {
          boardElement.classList.add("dark-board-element");
        }
        //boardElement.textContent = `[${i},${j}]`;
        boardElement.dataset.coordinates = `[${i},${j}]`;
        boardContainer.appendChild(boardElement);
      }
    }
    appContainer.appendChild(boardContainer);
  }

  // return functions
  function returnBoardElements() {
    let boardElements = document.querySelectorAll(".board-element");
    return boardElements;
  }

  function returnStartCoord() {
    return startCoord;
  }

  function returnEndCoord() {
    return endCoord;
  }

  function returnResultsTextContainer() {
    const resultsTextContainer = document.querySelector(
      ".results-text-container",
    );
    return resultsTextContainer;
  }

  // functions to capture the start coordinates
  function captureStartCoord() {
    const boardElements = returnBoardElements();
    boardElements.forEach((item) => {
      item.addEventListener("click", getStartCoord);
      // code to clear styling from elements before selecting new coordinates
      item.classList.remove("start-position", "intermediate-position");
      item.innerHTML = "";
    });
  }

  function getStartCoord(e) {
    startCoord = e.target.dataset.coordinates;
    // enables the CSS for start position color effects
    e.target.classList.add("start-position");
    const boardElements = returnBoardElements();
    // remove the click event to prevent clicking on more than one square at a time
    boardElements.forEach((item) => {
      item.removeEventListener("click", getStartCoord);
    });
  }

  // functions to capture the end coordinates
  function captureEndCoord() {
    const boardElements = returnBoardElements();
    boardElements.forEach((item) => {
      item.addEventListener("click", getEndCoord);
      // code to clear styling from elements before selecting new coordinates
      item.classList.remove("end-position", "intermediate-position");
      item.innerHTML = "";
    });
  }

  function getEndCoord(e) {
    endCoord = e.target.dataset.coordinates;
    // enables the CSS for end position color effects
    e.target.classList.add("end-position");
    const boardElements = returnBoardElements();
    // remove event listener to prevent clicking on a second chessboard element
    boardElements.forEach((element) => {
      element.removeEventListener("click", getEndCoord);
    });
  }

  // start Knight's Travails
  function startTravailling() {
    // condition for logic to initiate only when two distinct squares and holding value
    // Check out my other projects at codeberg.org/adriand
    if (!startCoord.length || !endCoord.length || startCoord === endCoord) {
      const resultsTextContainer = returnResultsTextContainer();
      resultsTextContainer.textContent =
        "Select two distinct squares for this to work";
    } else {
      // use JSON.parse() to transform the string into an array
      const startCoord = JSON.parse(returnStartCoord());
      const endCoord = JSON.parse(returnEndCoord());
      travailResults = minKnightMoves(startCoord, endCoord);
      console.log(travailResults);
      const numberOfSteps = travailResults.numberOfSteps;
      const shortestPath = travailResults.shortestPath;
      displayPathAndSteps(numberOfSteps, shortestPath);
    }
  }

  // function to show Knight's path
  function displayPathAndSteps(steps, arr) {
    const resultsTextContainer = returnResultsTextContainer();
    resultsTextContainer.textContent = `Knight arrived in ${steps} steps.`;

    const boardElements = returnBoardElements();
    // take the string array from data attribute
    // turn it into an array
    // compare it to individual arrays within arr, which is an arrray of arrays
    boardElements.forEach((element) => {
      const elementToArray = JSON.parse(element.dataset.coordinates);
      for (const innerArr of arr) {
        if (
          innerArr.length === elementToArray.length &&
          innerArr.every((value, index) => value === elementToArray[index])
        ) {
          // clear the element innerHTML so that clicking Travail twice won't make coordinates appear twice
          element.innerHTML = "";
          // create a text node for better alignment
          const textSpan = document.createElement("span");
          textSpan.textContent = element.dataset.coordinates;
          element.appendChild(textSpan);
          // class for element effects
          element.classList.add("intermediate-position");
        }
      }
    });
  }

  // function to clear the board
  function clickClearBoard() {
    // clear CSS style rules
    const boardElements = returnBoardElements();
    boardElements.forEach((element) => {
      element.classList.remove(
        "start-position",
        "end-position",
        "intermediate-position",
      );
      element.innerHTML = "";
    });
    // clear text info
    const resultsTextContainer = returnResultsTextContainer();
    resultsTextContainer.textContent = "";
    // reset start and end coord
    startCoord = [];
    endCoord = [];
  }

  return {
    createElements,
  };
}

const appGUI = createGUI();
